import { createSlice } from "@reduxjs/toolkit";

// Initial state for selected platform
const initialState = {
  selectedPlatformId: null, // null means use default (deloitte-global)
  platformName: null,
};

// Platform slice to store the currently selected platform
export const platformSlice = createSlice({
  name: "platform",
  initialState,
  reducers: {
    setSelectedPlatform: (state, action) => {
      state.selectedPlatformId = action.payload.platformId;
      state.platformName = action.payload.platformName;
    },
    clearSelectedPlatform: (state) => {
      state.selectedPlatformId = null;
      state.platformName = null;
    },
  },
});

export const { setSelectedPlatform, clearSelectedPlatform } = platformSlice.actions;
